import React, { Component } from "react";
import {
  Grid,
  Icon,
  Input,
  Button,
  Divider,
  Dropdown,
  Label,
} from "semantic-ui-react";
import moment from "moment";
import { hashHistory } from "react-router";
import Roundy from "../../../services/roundy";
import { createservice, grabserviceredux } from "../../../services/crudservice";
// import InvoiceTable from "./invoicetable";
class FixedInv extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoice: {
        custnumber: "",
        number: "1",
        workordernumber: "",
        description: "",
        periodbegindate: moment()
          .startOf("month")
          .subtract(1, "months")
          .format("YYYY-MM-DD"),
        periodenddate: moment()
          .endOf("month")
          .subtract(1, "months")
          .format("YYYY-MM-DD"),
        amount: 0,
        submitdate: null,
        paiddate: null,
        fixedpriceinv: 1,
        fixedpricepercent: 0,
        approved: null,
        notification: null,
        paidamount: 0,
      },
      inputmethod: "percentdrop",
      wod: null,
    };
  }
  gencreatebutton() {
    if (this.state.invoice.amount && this.state.invoice.workordernumber) {
      console.log("stateinvoice", this.state.invoice.id);
      var customer;
      if (this.props.customers && this.props.customers.length) {
        customer = this.props.customers.find(
          (cust) => cust.custnumber == this.state.invoice.custnumber
        );
      }
      if (!this.state.invoice.id) {
        return (
          <Button
            color="green"
            id="createinvbtn"
            onClick={() => {
              createservice(
                "invoices",
                {
                  ...this.state.invoice,
                  number: customer.nextinvnumber,
                  tmids: [],
                },
                "Invoices"
              ).then((res) => {
                console.log("responseid", res.id);
                this.setState({ invoice: res }, () =>
                  console.log("newinvoice", this.state.invoice)
                );
                grabserviceredux("invoices", "invoices");
                grabserviceredux("customers", "custreducer");
              });
            }}
          >
            Create Invoice <Icon name="check" />
          </Button>
        );
      } else {
        return (
          <Button
            color="blue"
            id="createinvbtn"
            onClick={() => {
              hashHistory.push("/invlist/" + this.state.invoice.id);
              window.location.reload();
            }}
          >
            View Invoice
          </Button>
        );
      }
    }
  }
  handlechargeinputbtn() {
    switch (this.state.inputmethod) {
      case "percentdrop":
        break;
      case "ammountInput":
        break;
    }
  }
  genpercentdrop() {
    if (this.state.wod) {
      console.log(this.state.wod);
      let existingCharge = 0;
      this.props.invoices.forEach((inv) => {
        if (inv.workordernumber === this.state.wod.workOrderNbr) {
          existingCharge += parseFloat(inv.amount);
        }
      });

      console.log("existingCharge", existingCharge);
      let chargedecimal = existingCharge / this.state.wod.budget;
      let chargepercent = chargedecimal * 100;
      console.log("existing charge percent is " + chargepercent + "%");
      let percentoptions = [];
      for (var i = 5; i <= 100; i += 5) {
        if (i > chargepercent) {
          let tempvalue = {
            chargeAmount: Roundy(
              (i / 100) * this.state.wod.budget - existingCharge
            ),
            chargePercent: i,
          };
          let percentry = {
            key: i,
            value: tempvalue,
            text: tempvalue.chargePercent + "% - $" + tempvalue.chargeAmount,
          };
          percentoptions = percentoptions.concat(percentry);
        }
      }
      return percentoptions;
    }
  }

  gendateinputs() {
    let tempinvce = this.state.invoice;
    if (this.state.wod && this.state.invoice.amount) {
      return (
        <Grid.Row>
          <Grid.Column width={4}>
            <Label attached="top left">Period Begin Date</Label>
            <Input
              type="date"
              fluid
              placeholder="MM/DD/YYYY"
              value={this.state.invoice.periodbegindate}
              onChange={(e) => {
                tempinvce.periodbegindate = moment(e.target.value).format(
                  "YYYY-MM-DD"
                );
                this.setState({
                  invoice: tempinvce,
                });
              }}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <div>
              <Label id="fixedlabel" attached="top left">
                Period End Date
              </Label>
              <Input
                type="date"
                fluid
                placeholder="MM/DD/YYYY"
                value={this.state.invoice.periodenddate}
                onChange={(e) => {
                  tempinvce.periodenddate = moment(e.target.value).format(
                    "YYYY-MM-DD"
                  );
                  this.setState({
                    invoice: tempinvce,
                  });
                }}
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      );
    }
  }
  genchargeinput() {
    let tempinvce = this.state.invoice;
    if (this.state.wod) {
      switch (this.state.inputmethod) {
        case "percentdrop":
          return (
            <div>
              <Label attached="top left">Invoice Amount Percent</Label>
              <Dropdown
                fluid
                options={this.genpercentdrop()}
                search
                selection
                onChange={(e, { value }) => {
                  tempinvce.amount = value.chargeAmount;
                  tempinvce.fixedpricepercent = value.chargePercent;
                  this.setState({
                    invoice: tempinvce,
                    invpercent: value.chargePercent,
                  });
                }}
              />
            </div>
          );
          break;
        case "amountInput":
          return (
            <div>
              <Label id="fixedlabel" attached="top left">
                Invoice Amount
              </Label>
              <Input
                type="number"
                icon="dollar"
                iconPosition="left"
                placeholder="Amount"
                error={
                  this.state.invoice.amount > parseInt(this.state.wod.remaining)
                }
                onChange={(e) => {
                  tempinvce.amount = e.target.value;
                  tempinvce.fixedpricepercent = 0;
                  if (this.state.invoice.amount > this.state.wod.remaining) {
                    console.log("too much");
                  }
                  this.setState({
                    invoice: tempinvce,
                  });
                }}
              />
            </div>
          );

          break;
        default:
      }
    }
  }
  render() {
    let tempinv = this.state.invoice;

    return (
      <div className="FixedInv">
        <Grid>
          <Grid.Row>
            <Grid.Column width={5}>
              <Label>Work Order</Label>
              <Dropdown
                fluid
                search
                selection
                options={this.props.wodoptions}
                onChange={(e, { value }) => {
                  tempinv = {
                    ...tempinv,
                    workordernumber: value.workOrderNbr,
                    custnumber: value.custnumber,
                    description: value.description,
                  };
                  this.setState({ invoice: tempinv, wod: value });
                }}
              />
            </Grid.Column>
            <Grid.Column width={1} centered>
              <Button.Group id="createinvbtn">
                <Button
                  disabled={!this.state.wod}
                  basic={this.state.inputmethod === "amountInput"}
                  onClick={() =>
                    this.setState({ inputmethod: "percentdrop" }, () =>
                      console.log("Input Method", this.state.inputmethod)
                    )
                  }
                  color="blue"
                >
                  %
                </Button>
                <Button.Or />

                <Button
                  disabled={!this.state.wod}
                  basic={this.state.inputmethod === "percentdrop"}
                  color="blue"
                  onClick={() => this.setState({ inputmethod: "amountInput" })}
                >
                  $
                </Button>
              </Button.Group>
            </Grid.Column>
            <Grid.Column width={4}>{this.genchargeinput()}</Grid.Column>
            <Grid.Column width={2}>{this.gencreatebutton()}</Grid.Column>
          </Grid.Row>
          <Divider />
          {this.gendateinputs()}
        </Grid>
      </div>
    );
  }
}
export default FixedInv;



// WEBPACK FOOTER //
// ./src/components/accounting/invoices/fixedinv.js